// Suara pesanan Konsultasi Sekarang. Browser hanya mengizinkan audio setelah klik pengguna.
const KEY_ON = "gbs_now_sound";
const KEY_SEEN = "gbs_now_alerted";
let ctx;

const audio = () => {
  try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ctx = null; }
  return ctx;
};

const tone = (c, freq, at) => {
  const o = c.createOscillator();
  const g = c.createGain();
  o.connect(g); g.connect(c.destination);
  o.type = "sine"; o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime + at);
  g.gain.exponentialRampToValueAtTime(0.2, c.currentTime + at + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + at + 0.3);
  o.start(c.currentTime + at); o.stop(c.currentTime + at + 0.32);
};

export const soundOn = () => localStorage.getItem(KEY_ON) === "on";
export const audioReady = () => !!ctx && ctx.state === "running";

export function chime() {
  const c = audio();
  if (!c) return false;
  try {
    if (c.state === "suspended") c.resume();
    tone(c, 880, 0); tone(c, 660, 0.35); tone(c, 880, 0.7);
  } catch (e) { return false; }
  return true;
}

export function enableSound() {
  localStorage.setItem(KEY_ON, "on");
  return chime();
}

export function unlockAudio() {
  const c = audio();
  try { if (c && c.state === "suspended") c.resume(); } catch (e) { /* butuh klik pengguna */ }
}

export function disableSound() { localStorage.setItem(KEY_ON, "off"); }

// True hanya sekali per pesanan (kunci reservasi + batas Terima), lintas polling/tab.
export function firstAlert(key) {
  let seen = [];
  try { seen = JSON.parse(localStorage.getItem(KEY_SEEN) || "[]"); } catch (e) { seen = []; }
  if (seen.includes(key)) return false;
  localStorage.setItem(KEY_SEEN, JSON.stringify([...seen.slice(-30), key]));
  return true;
}
